import type { FileSource, Scheme } from '@personly/libs-types';

export type SrcSet = {
  src: string;
  width: number;
  height: number;
  alt: string;
};

type SchemeSrcSet = {
  src: string;
  width: number;
  height: number;
  alt: string;
  fileName: string;
};

const makeFileSrcSet = (
  fileSource: FileSource,
  desiredWidth?: number
): SrcSet => {
  const { metadata, url, alt } = fileSource;
  const ratio = parseInt(metadata.height, 10) / parseInt(metadata.width, 10);
  const width = desiredWidth || parseInt(metadata.width, 10);
  const height = Math.round(ratio * width);
  return { src: url, height, width, alt };
};

const makeFileSrcSets = (
  fileSources: Record<string, FileSource>,
  width?: number
) =>
  Object.keys(fileSources).reduce<Record<string, SrcSet>>(
    (acc, schemeHandle) => ({
      ...acc,
      [schemeHandle]: makeFileSrcSet(fileSources[schemeHandle], width),
    }),
    {}
  );

const makeSchemeSrcSet = (scheme: Scheme, height: number, alt: string) => {
  const width = Math.floor(height * 4);
  const fileName = `personly-heading-${scheme.id.toLowerCase()}.svg`;
  const src = `/images/brands/${fileName}`;
  return { src, width, height, alt, fileName };
};

const makeSchemeSrcSets = (
  schemes: Array<Scheme>,
  height: number,
  alt: string
) =>
  schemes
    .filter(({ flags }) => flags.browser)
    .reduce<Record<string, SchemeSrcSet>>(
      (acc, scheme) => ({
        ...acc,
        [scheme.id]: makeSchemeSrcSet(scheme, height, alt),
      }),
      {}
    );

export { makeFileSrcSets, makeSchemeSrcSets };
